export function isSafari() {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
}